import { render, staticRenderFns } from "./document.vue?vue&type=template&id=4b2a121c&scoped=true&"
var script = {}
import style0 from "./document.scss?vue&type=style&index=0&id=4b2a121c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a121c",
  null
  
)

export default component.exports